<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sBlQCa/tc-custom/9781504090711.jpg?1725275551070" alt="This image is the cover for the book Sunday's Child"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sunday's Child
      </h1>
      <p class="bookDescription body article font2">
        <b>A new thriller by the author of <i>The Desperate Wife</i>: Sometimes the ones closest to us are the ones with the most to hide . . .</b><br/><br/> Thirteen-year-old Kaleb has gone missing—and Laney Atkinson and her sister are keeping a secret: their kids were the last to see Kaleb alive. With the neighborhood in a panic, they don’t want their children traumatised by police interviews and pointing fingers.<br/><br/> Instead, Laney devotes herself to trying to find Kaleb. But any lingering hope for a happy ending is lost when the boy’s body is discovered days later. Sure enough, gossip and suspicion engulf the community.<br/><br/> Laney, though, has her own suspicions about the tragedy, and they involve someone close to her. As tensions erupt within her family and a shocking secret is revealed, will the truth bring her relief—or shatter her world?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        C. L. Jennison
      </h2>
      
      <p class="authorDescription body article">C.L. Jennison (Claire) has been helping fellow authors with their book editing, ghostwriting and formatting needs since 2018 through her business Penning and Planning. Prior to that, as a qualified teacher, she taught English and English literature for over twelve years, after achieving her English and Creative Writing degree. And before that, she worked at Grimsby Evening Telegraph in the newspaper planning department. She has always worked with words and/or publications!<BR /><BR /> Claire is proud to finally write and publish novels under her own name and is now living her dream as a hybrid author! Claire lives in Hull, East Yorkshire, with her husband, dog and cat. She is happiest when she is absorbed in a twisty psychological thriller with her adorable animals by her side.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33878793